import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Torremolinos"
      slug="torremolinos"
      poblacion={71270}
      lat={36.6203}
      lng={-4.4998}
      neighborhoodsText="Trabajamos en El Bajondillo, La Carihuela, Montemar, Playamar, El Pinillo y Los Álamos. Especializados en edificios turísticos y apartamentos de costa."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Torremolinos?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Torremolinos?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}